export default function CustomCursor() {
  // Disabled custom cursor - using normal browser cursor
  return null;
}
